// The attribute and sort direction
// Do not change this enum value, its format must match with the format in algolia
export enum IndexSort {
    // Sorts the index by relevance
    Default = "",
    PriceAsc = "price_asc",
    PriceDesc = "price_desc"
}
